import { type Transaction, TransactionSide } from "@/apis/gql/types";
import { BankTransactionBankAccountIcon } from "@/components/shared/bank-transactions/bank-transaction-bank-account-icon";
import { SignedAmount } from "@/components/shared/miscellaneous/signed-amount";
import TextWithTooltip from "@/components/shared/tooltips/text-with-tooltip";
import {
  TypographyCaption,
  TypographyMuted,
  TypographySmall,
} from "@/components/ui/typography";
import { cn, formatAmount } from "@/lib/utils";
import type { InvoiceDetailsTransaction } from "@/queries/invoices/get";
import { format } from "date-fns";
type Props = {
  transaction: Transaction;
};

export const TransactionCell = ({ transaction }: Props) => {
  return (
    <TransactionCard
      transaction={transaction}
      icon={<BankTransactionBankAccountIcon transaction={transaction} />}
    />
  );
};

export function TransactionCard({
  transaction,
  icon,
}: {
  transaction: InvoiceDetailsTransaction;
  icon?: React.ReactNode;
}) {
  return (
    <div className="flex flex-row gap-4 p-2 w-full items-center overflow-hidden h-[92px]">
      {icon}
      <div className="flex flex-col min-h-[56px] flex-grow overflow-hidden">
        <TypographyCaption className="text-xs text-muted-foreground">
          {format(
            transaction.bookingDate || transaction.createdAt,
            "dd.MM.yyyy",
          )}
        </TypographyCaption>
        <TypographySmall className="text-sm">
          {transaction.counterpartyName}
        </TypographySmall>
        <TextWithTooltip text={transaction.purpose}>
          <TypographyMuted className="text-sm text-muted-foreground truncate">
            {transaction.purpose}
          </TypographyMuted>
        </TextWithTooltip>
      </div>
      <div className="flex flex-col items-end justify-center">
        <SignedAmount
          amount={transaction.amount}
          currency={transaction.currency}
          side={transaction.side}
          originalAmount={transaction.originalAmount}
          originalCurrency={transaction.originalCurrency}
        />
      </div>
    </div>
  );
}
